// @generated by bzl gen
// @generated by protoc-gen-es v0.2.1 with parameter "target=ts"
// @generated from file dropbox/proto/context_engine/models.proto (package context_engine, syntax proto3)
/* eslint-disable */
/* @ts-nocheck */

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage,
} from "@bufbuild/protobuf";
import {
  BytesValue,
  Empty,
  Message,
  proto3,
  protoInt64,
} from "@bufbuild/protobuf";
import {
  CE_Channel,
  CE_ConnectorInfo,
  CE_FileTypeInfo,
} from "./connector_info_pb";
import { WorkingHours, WorkingHoursPerDay } from "./user_preferences_pb";

/**
 * @generated from enum context_engine.PromptMessageRole
 */
export enum PromptMessageRole {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SYSTEM = 1;
   */
  SYSTEM = 1,

  /**
   * @generated from enum value: USER = 2;
   */
  USER = 2,

  /**
   * @generated from enum value: ASSISTANT = 3;
   */
  ASSISTANT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PromptMessageRole)
proto3.util.setEnumType(PromptMessageRole, "context_engine.PromptMessageRole", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "SYSTEM" },
  { no: 2, name: "USER" },
  { no: 3, name: "ASSISTANT" },
]);

/**
 * @generated from message context_engine.AuthedUser
 */
export class AuthedUser extends Message<AuthedUser> {
  /**
   * @generated from field: int64 user_id = 1;
   */
  userId = protoInt64.zero;

  /**
   * @generated from field: string email = 2;
   */
  email = "";

  /**
   * @generated from field: string display_name = 3;
   */
  displayName = "";

  constructor(data?: PartialMessage<AuthedUser>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.AuthedUser";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 3,
      name: "display_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): AuthedUser {
    return new AuthedUser().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): AuthedUser {
    return new AuthedUser().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): AuthedUser {
    return new AuthedUser().fromJsonString(jsonString, options);
  }

  static equals(
    a: AuthedUser | PlainMessage<AuthedUser> | undefined,
    b: AuthedUser | PlainMessage<AuthedUser> | undefined,
  ): boolean {
    return proto3.util.equals(AuthedUser, a, b);
  }
}

/**
 * @generated from message context_engine.Contact
 */
export class Contact extends Message<Contact> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  constructor(data?: PartialMessage<Contact>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.Contact";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "display_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): Contact {
    return new Contact().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): Contact {
    return new Contact().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): Contact {
    return new Contact().fromJsonString(jsonString, options);
  }

  static equals(
    a: Contact | PlainMessage<Contact> | undefined,
    b: Contact | PlainMessage<Contact> | undefined,
  ): boolean {
    return proto3.util.equals(Contact, a, b);
  }
}

/**
 * @generated from message context_engine.TimeBlock
 */
export class TimeBlock extends Message<TimeBlock> {
  /**
   * @generated from field: int64 start_ms = 1;
   */
  startMs = protoInt64.zero;

  /**
   * @generated from field: int64 end_ms = 2;
   */
  endMs = protoInt64.zero;

  constructor(data?: PartialMessage<TimeBlock>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.TimeBlock";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "end_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): TimeBlock {
    return new TimeBlock().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): TimeBlock {
    return new TimeBlock().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): TimeBlock {
    return new TimeBlock().fromJsonString(jsonString, options);
  }

  static equals(
    a: TimeBlock | PlainMessage<TimeBlock> | undefined,
    b: TimeBlock | PlainMessage<TimeBlock> | undefined,
  ): boolean {
    return proto3.util.equals(TimeBlock, a, b);
  }
}

/**
 * @generated from message context_engine.MeetingAttendee
 */
export class MeetingAttendee extends Message<MeetingAttendee> {
  /**
   * @generated from field: context_engine.Contact contact = 1;
   */
  contact?: Contact;

  /**
   * For gcal, this is one of "needsAction", "declined", "tentative", "accepted"
   *
   * @generated from field: string rsvp_status = 2;
   */
  rsvpStatus = "";

  constructor(data?: PartialMessage<MeetingAttendee>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.MeetingAttendee";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact", kind: "message", T: Contact },
    {
      no: 2,
      name: "rsvp_status",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): MeetingAttendee {
    return new MeetingAttendee().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): MeetingAttendee {
    return new MeetingAttendee().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): MeetingAttendee {
    return new MeetingAttendee().fromJsonString(jsonString, options);
  }

  static equals(
    a: MeetingAttendee | PlainMessage<MeetingAttendee> | undefined,
    b: MeetingAttendee | PlainMessage<MeetingAttendee> | undefined,
  ): boolean {
    return proto3.util.equals(MeetingAttendee, a, b);
  }
}

/**
 * @generated from message context_engine.MeetingInfo
 */
export class MeetingInfo extends Message<MeetingInfo> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * An absolute link to this event in the Google Calendar Web UI
   *
   * @generated from field: string url = 2;
   */
  url = "";

  /**
   * short summary of the meeting, like a title, e.g. "Team Standup"
   *
   * @generated from field: string summary = 3;
   */
  summary = "";

  /**
   * email address of the person who created the meeting
   *
   * @generated from field: string creator = 4;
   */
  creator = "";

  /**
   * status of the meeting from calendar backend
   * For gcal, this is one of "confirmed", "tentative", or "cancelled"
   *
   * @generated from field: string status = 5;
   */
  status = "";

  /**
   * long form description of the meeting
   *
   * @generated from field: string description = 6;
   */
  description = "";

  /**
   * Start time of the meeting in milliseconds seince unix epoch
   *
   * @generated from field: int64 start_ms = 7;
   */
  startMs = protoInt64.zero;

  /**
   * End time of the meeting in milliseconds seince unix epoch
   *
   * @generated from field: int64 end_ms = 8;
   */
  endMs = protoInt64.zero;

  /**
   * whether this meeting is marked as free or busy on your calendar
   *
   * @generated from field: bool is_free = 10;
   */
  isFree = false;

  /**
   * List of attendees for the meeting
   *
   * @generated from field: repeated context_engine.MeetingAttendee attendees = 11;
   */
  attendees: MeetingAttendee[] = [];

  constructor(data?: PartialMessage<MeetingInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.MeetingInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "summary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 6,
      name: "description",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 7, name: "start_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "end_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "is_free", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 11,
      name: "attendees",
      kind: "message",
      T: MeetingAttendee,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): MeetingInfo {
    return new MeetingInfo().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): MeetingInfo {
    return new MeetingInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): MeetingInfo {
    return new MeetingInfo().fromJsonString(jsonString, options);
  }

  static equals(
    a: MeetingInfo | PlainMessage<MeetingInfo> | undefined,
    b: MeetingInfo | PlainMessage<MeetingInfo> | undefined,
  ): boolean {
    return proto3.util.equals(MeetingInfo, a, b);
  }
}

/**
 * @generated from message context_engine.ConflictingMeetingGroup
 */
export class ConflictingMeetingGroup extends Message<ConflictingMeetingGroup> {
  /**
   * @generated from field: repeated context_engine.MeetingInfo meetings = 1;
   */
  meetings: MeetingInfo[] = [];

  constructor(data?: PartialMessage<ConflictingMeetingGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConflictingMeetingGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "meetings",
      kind: "message",
      T: MeetingInfo,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConflictingMeetingGroup {
    return new ConflictingMeetingGroup().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConflictingMeetingGroup {
    return new ConflictingMeetingGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConflictingMeetingGroup {
    return new ConflictingMeetingGroup().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ConflictingMeetingGroup
      | PlainMessage<ConflictingMeetingGroup>
      | undefined,
    b:
      | ConflictingMeetingGroup
      | PlainMessage<ConflictingMeetingGroup>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConflictingMeetingGroup, a, b);
  }
}

/**
 * @generated from message context_engine.ConflictingMeetings
 */
export class ConflictingMeetings extends Message<ConflictingMeetings> {
  /**
   * @generated from field: repeated context_engine.ConflictingMeetingGroup groups = 1;
   */
  groups: ConflictingMeetingGroup[] = [];

  constructor(data?: PartialMessage<ConflictingMeetings>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConflictingMeetings";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "groups",
      kind: "message",
      T: ConflictingMeetingGroup,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConflictingMeetings {
    return new ConflictingMeetings().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConflictingMeetings {
    return new ConflictingMeetings().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConflictingMeetings {
    return new ConflictingMeetings().fromJsonString(jsonString, options);
  }

  static equals(
    a: ConflictingMeetings | PlainMessage<ConflictingMeetings> | undefined,
    b: ConflictingMeetings | PlainMessage<ConflictingMeetings> | undefined,
  ): boolean {
    return proto3.util.equals(ConflictingMeetings, a, b);
  }
}

/**
 * @generated from message context_engine.ContextUserError
 */
export class ContextUserError extends Message<ContextUserError> {
  /**
   * @generated from field: string message = 1;
   */
  message = "";

  constructor(data?: PartialMessage<ContextUserError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ContextUserError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ContextUserError {
    return new ContextUserError().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ContextUserError {
    return new ContextUserError().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ContextUserError {
    return new ContextUserError().fromJsonString(jsonString, options);
  }

  static equals(
    a: ContextUserError | PlainMessage<ContextUserError> | undefined,
    b: ContextUserError | PlainMessage<ContextUserError> | undefined,
  ): boolean {
    return proto3.util.equals(ContextUserError, a, b);
  }
}

/**
 * @generated from message context_engine.SharedLinkInfo
 */
export class SharedLinkInfo extends Message<SharedLinkInfo> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: google.protobuf.BytesValue encrypted_grant_book = 2;
   */
  encryptedGrantBook?: Uint8Array;

  constructor(data?: PartialMessage<SharedLinkInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.SharedLinkInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "encrypted_grant_book", kind: "message", T: BytesValue },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): SharedLinkInfo {
    return new SharedLinkInfo().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): SharedLinkInfo {
    return new SharedLinkInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): SharedLinkInfo {
    return new SharedLinkInfo().fromJsonString(jsonString, options);
  }

  static equals(
    a: SharedLinkInfo | PlainMessage<SharedLinkInfo> | undefined,
    b: SharedLinkInfo | PlainMessage<SharedLinkInfo> | undefined,
  ): boolean {
    return proto3.util.equals(SharedLinkInfo, a, b);
  }
}

/**
 * @generated from message context_engine.FssFileIdentifier
 */
export class FssFileIdentifier extends Message<FssFileIdentifier> {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId = "";

  /**
   * @generated from field: context_engine.SharedLinkInfo link_info = 2;
   */
  linkInfo?: SharedLinkInfo;

  constructor(data?: PartialMessage<FssFileIdentifier>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.FssFileIdentifier";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "link_info", kind: "message", T: SharedLinkInfo },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): FssFileIdentifier {
    return new FssFileIdentifier().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): FssFileIdentifier {
    return new FssFileIdentifier().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): FssFileIdentifier {
    return new FssFileIdentifier().fromJsonString(jsonString, options);
  }

  static equals(
    a: FssFileIdentifier | PlainMessage<FssFileIdentifier> | undefined,
    b: FssFileIdentifier | PlainMessage<FssFileIdentifier> | undefined,
  ): boolean {
    return proto3.util.equals(FssFileIdentifier, a, b);
  }
}

/**
 * @generated from message context_engine.FssRetrieverInfo
 */
export class FssRetrieverInfo extends Message<FssRetrieverInfo> {
  /**
   * @generated from field: string search_query = 1;
   */
  searchQuery = "";

  /**
   * @generated from field: uint64 ns_id = 2;
   */
  nsId = protoInt64.zero;

  /**
   * @generated from field: string ns_path = 3;
   */
  nsPath = "";

  /**
   * @generated from field: context_engine.FssFileIdentifier fss_file_identifier = 4;
   */
  fssFileIdentifier?: FssFileIdentifier;

  /**
   * @generated from field: uint64 page_number = 5;
   */
  pageNumber = protoInt64.zero;

  /**
   * @generated from field: bool paginated = 6;
   */
  paginated = false;

  constructor(data?: PartialMessage<FssRetrieverInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.FssRetrieverInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "search_query",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "ns_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "ns_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 4,
      name: "fss_file_identifier",
      kind: "message",
      T: FssFileIdentifier,
    },
    {
      no: 5,
      name: "page_number",
      kind: "scalar",
      T: 4 /* ScalarType.UINT64 */,
    },
    { no: 6, name: "paginated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): FssRetrieverInfo {
    return new FssRetrieverInfo().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): FssRetrieverInfo {
    return new FssRetrieverInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): FssRetrieverInfo {
    return new FssRetrieverInfo().fromJsonString(jsonString, options);
  }

  static equals(
    a: FssRetrieverInfo | PlainMessage<FssRetrieverInfo> | undefined,
    b: FssRetrieverInfo | PlainMessage<FssRetrieverInfo> | undefined,
  ): boolean {
    return proto3.util.equals(FssRetrieverInfo, a, b);
  }
}

/**
 * @generated from message context_engine.DocumentInfo
 */
export class DocumentInfo extends Message<DocumentInfo> {
  /**
   * web link url to the document
   *
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * title of the document
   *
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * last updated time of the document
   *
   * @generated from field: int64 last_updated_ms = 3;
   */
  lastUpdatedMs = protoInt64.zero;

  /**
   * type of the document
   *
   * @generated from field: string branded_type = 4;
   */
  brandedType = "";

  /**
   * body of the document
   *
   * @generated from field: string body = 5;
   */
  body = "";

  /**
   * owner id of the document
   *
   * @generated from field: string owner_id = 6;
   */
  ownerId = "";

  /**
   * third party id of the document (e.g. google doc id or dropbox file id)
   *
   * @generated from field: string third_party_id = 7;
   */
  thirdPartyId = "";

  /**
   * search relevance score of the document
   *
   * @generated from field: float relevance_score = 8;
   */
  relevanceScore = 0;

  /**
   * info about the connector the document came from
   *
   * @generated from field: context_engine.CE_ConnectorInfo connector_info = 9;
   */
  connectorInfo?: CE_ConnectorInfo;

  /**
   * uuid that tracks the document
   *
   * @generated from field: string uuid = 10;
   */
  uuid = "";

  /**
   * info about the file type
   *
   * @generated from field: context_engine.CE_FileTypeInfo file_type_info = 11;
   */
  fileTypeInfo?: CE_FileTypeInfo;

  /**
   * info about the index of the document in the LLM request (for citations)
   *
   * @generated from field: string index = 12;
   */
  index = "";

  /**
   * info about the document's retrieval source
   *
   * @generated from field: string retrieval_source = 13;
   */
  retrievalSource = "";

  /**
   * info about citation type
   *
   * @generated from field: string citation_type = 14;
   */
  citationType = "";

  /**
   * info specific to the FSSRetriever for the document
   *
   * @generated from field: context_engine.FssRetrieverInfo fss_retriever_info = 15;
   */
  fssRetrieverInfo?: FssRetrieverInfo;

  /**
   * Relevant for user-provided attachments - boolean to determine whether or not
   * document body should be persisted. Transient docs are only used for one turn
   * and then their content is discarded.
   *
   * @generated from field: bool transient = 16;
   */
  transient = false;

  /**
   * multi-modal body of the document
   *
   * @generated from field: context_engine.DocumentContent document_content = 17;
   */
  documentContent?: DocumentContent;

  /**
   * Optional for messages
   *
   * @generated from field: context_engine.CE_Channel channel = 18;
   */
  channel?: CE_Channel;

  constructor(data?: PartialMessage<DocumentInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DocumentInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 3,
      name: "last_updated_ms",
      kind: "scalar",
      T: 3 /* ScalarType.INT64 */,
    },
    {
      no: 4,
      name: "branded_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 5, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "owner_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 7,
      name: "third_party_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 8,
      name: "relevance_score",
      kind: "scalar",
      T: 2 /* ScalarType.FLOAT */,
    },
    { no: 9, name: "connector_info", kind: "message", T: CE_ConnectorInfo },
    { no: 10, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "file_type_info", kind: "message", T: CE_FileTypeInfo },
    { no: 12, name: "index", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 13,
      name: "retrieval_source",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 14,
      name: "citation_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 15,
      name: "fss_retriever_info",
      kind: "message",
      T: FssRetrieverInfo,
    },
    { no: 16, name: "transient", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "document_content", kind: "message", T: DocumentContent },
    { no: 18, name: "channel", kind: "message", T: CE_Channel },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DocumentInfo {
    return new DocumentInfo().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DocumentInfo {
    return new DocumentInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DocumentInfo {
    return new DocumentInfo().fromJsonString(jsonString, options);
  }

  static equals(
    a: DocumentInfo | PlainMessage<DocumentInfo> | undefined,
    b: DocumentInfo | PlainMessage<DocumentInfo> | undefined,
  ): boolean {
    return proto3.util.equals(DocumentInfo, a, b);
  }
}

/**
 * @generated from message context_engine.DocumentContextProto
 */
export class DocumentContextProto extends Message<DocumentContextProto> {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: string body = 3;
   */
  body = "";

  /**
   * @generated from field: int64 last_updated = 4;
   */
  lastUpdated = protoInt64.zero;

  /**
   * @generated from field: context_engine.DocumentContent mm_context = 5;
   */
  mmContext?: DocumentContent;

  /**
   * @generated from field: int32 index = 6;
   */
  index = 0;

  /**
   * @generated from field: string retrieval_source = 7;
   */
  retrievalSource = "";

  /**
   * @generated from field: string connector_display_name = 8;
   */
  connectorDisplayName = "";

  /**
   * @generated from field: string file_type_display_name = 9;
   */
  fileTypeDisplayName = "";

  constructor(data?: PartialMessage<DocumentContextProto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DocumentContextProto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "document_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 4,
      name: "last_updated",
      kind: "scalar",
      T: 3 /* ScalarType.INT64 */,
    },
    { no: 5, name: "mm_context", kind: "message", T: DocumentContent },
    { no: 6, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    {
      no: 7,
      name: "retrieval_source",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 8,
      name: "connector_display_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 9,
      name: "file_type_display_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DocumentContextProto {
    return new DocumentContextProto().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DocumentContextProto {
    return new DocumentContextProto().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DocumentContextProto {
    return new DocumentContextProto().fromJsonString(jsonString, options);
  }

  static equals(
    a: DocumentContextProto | PlainMessage<DocumentContextProto> | undefined,
    b: DocumentContextProto | PlainMessage<DocumentContextProto> | undefined,
  ): boolean {
    return proto3.util.equals(DocumentContextProto, a, b);
  }
}

/**
 * The content of a document.
 *
 * @generated from message context_engine.DocumentContent
 */
export class DocumentContent extends Message<DocumentContent> {
  /**
   * @generated from field: repeated context_engine.PageContent pages = 1;
   */
  pages: PageContent[] = [];

  constructor(data?: PartialMessage<DocumentContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DocumentContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pages", kind: "message", T: PageContent, repeated: true },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DocumentContent {
    return new DocumentContent().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DocumentContent {
    return new DocumentContent().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DocumentContent {
    return new DocumentContent().fromJsonString(jsonString, options);
  }

  static equals(
    a: DocumentContent | PlainMessage<DocumentContent> | undefined,
    b: DocumentContent | PlainMessage<DocumentContent> | undefined,
  ): boolean {
    return proto3.util.equals(DocumentContent, a, b);
  }
}

/**
 * The content of a page of a document.
 *
 * @generated from message context_engine.PageContent
 */
export class PageContent extends Message<PageContent> {
  /**
   * @generated from field: repeated context_engine.PageItem items = 1;
   */
  items: PageItem[] = [];

  /**
   * zero-based page number
   *
   * @generated from field: int64 page_num = 2;
   */
  pageNum = protoInt64.zero;

  constructor(data?: PartialMessage<PageContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.PageContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: PageItem, repeated: true },
    { no: 2, name: "page_num", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): PageContent {
    return new PageContent().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): PageContent {
    return new PageContent().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): PageContent {
    return new PageContent().fromJsonString(jsonString, options);
  }

  static equals(
    a: PageContent | PlainMessage<PageContent> | undefined,
    b: PageContent | PlainMessage<PageContent> | undefined,
  ): boolean {
    return proto3.util.equals(PageContent, a, b);
  }
}

/**
 * A single content item in a page of a document, e.g. a block of text or an embedded image.
 *
 * @generated from message context_engine.PageItem
 */
export class PageItem extends Message<PageItem> {
  /**
   * @generated from oneof context_engine.PageItem.content
   */
  content:
    | {
        /**
         * @generated from field: string text = 1;
         */
        value: string;
        case: "text";
      }
    | {
        /**
         * @generated from field: context_engine.ImageContent image = 2;
         */
        value: ImageContent;
        case: "image";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PageItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.PageItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "text",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      oneof: "content",
    },
    {
      no: 2,
      name: "image",
      kind: "message",
      T: ImageContent,
      oneof: "content",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): PageItem {
    return new PageItem().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): PageItem {
    return new PageItem().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): PageItem {
    return new PageItem().fromJsonString(jsonString, options);
  }

  static equals(
    a: PageItem | PlainMessage<PageItem> | undefined,
    b: PageItem | PlainMessage<PageItem> | undefined,
  ): boolean {
    return proto3.util.equals(PageItem, a, b);
  }
}

/**
 * @generated from message context_engine.ImageContent
 */
export class ImageContent extends Message<ImageContent> {
  /**
   * @generated from field: string url = 1;
   */
  url = "";

  /**
   * @generated from field: google.protobuf.BytesValue bytes = 2;
   */
  bytes?: Uint8Array;

  constructor(data?: PartialMessage<ImageContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ImageContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bytes", kind: "message", T: BytesValue },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ImageContent {
    return new ImageContent().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ImageContent {
    return new ImageContent().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ImageContent {
    return new ImageContent().fromJsonString(jsonString, options);
  }

  static equals(
    a: ImageContent | PlainMessage<ImageContent> | undefined,
    b: ImageContent | PlainMessage<ImageContent> | undefined,
  ): boolean {
    return proto3.util.equals(ImageContent, a, b);
  }
}

/**
 * @generated from message context_engine.AnswerInfo
 */
export class AnswerInfo extends Message<AnswerInfo> {
  /**
   * answer text
   *
   * @generated from field: string answer = 1;
   */
  answer = "";

  /**
   * confidence of the answer
   *
   * @generated from field: float confidence = 2;
   */
  confidence = 0;

  /**
   * sources of the answer
   *
   * @generated from field: repeated string source_url = 3;
   */
  sourceUrl: string[] = [];

  /**
   * @generated from field: repeated context_engine.DocumentInfo sources = 4;
   */
  sources: DocumentInfo[] = [];

  /**
   * @generated from field: string query = 5;
   */
  query = "";

  constructor(data?: PartialMessage<AnswerInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.AnswerInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "answer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "confidence", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    {
      no: 3,
      name: "source_url",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 4,
      name: "sources",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    { no: 5, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): AnswerInfo {
    return new AnswerInfo().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): AnswerInfo {
    return new AnswerInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): AnswerInfo {
    return new AnswerInfo().fromJsonString(jsonString, options);
  }

  static equals(
    a: AnswerInfo | PlainMessage<AnswerInfo> | undefined,
    b: AnswerInfo | PlainMessage<AnswerInfo> | undefined,
  ): boolean {
    return proto3.util.equals(AnswerInfo, a, b);
  }
}

/**
 * @generated from message context_engine.ContextEngineModelItem
 */
export class ContextEngineModelItem extends Message<ContextEngineModelItem> {
  /**
   * @generated from oneof context_engine.ContextEngineModelItem.data
   */
  data:
    | {
        /**
         * @generated from field: int64 int_value = 1;
         */
        value: bigint;
        case: "intValue";
      }
    | {
        /**
         * @generated from field: float float_value = 2;
         */
        value: number;
        case: "floatValue";
      }
    | {
        /**
         * @generated from field: string string_value = 3;
         */
        value: string;
        case: "stringValue";
      }
    | {
        /**
         * @generated from field: bool bool_value = 4;
         */
        value: boolean;
        case: "boolValue";
      }
    | {
        /**
         * @generated from field: google.protobuf.Empty empty_value = 5;
         */
        value: Empty;
        case: "emptyValue";
      }
    | {
        /**
         * @generated from field: string datetime_value = 6;
         */
        value: string;
        case: "datetimeValue";
      }
    | {
        /**
         * @generated from field: context_engine.AuthedUser authed_user = 7;
         */
        value: AuthedUser;
        case: "authedUser";
      }
    | {
        /**
         * @generated from field: context_engine.Contact contact = 8;
         */
        value: Contact;
        case: "contact";
      }
    | {
        /**
         * @generated from field: context_engine.TimeBlock time_block = 9;
         */
        value: TimeBlock;
        case: "timeBlock";
      }
    | {
        /**
         * @generated from field: context_engine.WorkingHours working_hours = 10;
         */
        value: WorkingHours;
        case: "workingHours";
      }
    | {
        /**
         * @generated from field: context_engine.MeetingInfo meeting_info = 11;
         */
        value: MeetingInfo;
        case: "meetingInfo";
      }
    | {
        /**
         * @generated from field: context_engine.ConflictingMeetings conflicting_meetings = 12;
         */
        value: ConflictingMeetings;
        case: "conflictingMeetings";
      }
    | {
        /**
         * @generated from field: context_engine.ContextUserError context_user_error = 13;
         */
        value: ContextUserError;
        case: "contextUserError";
      }
    | {
        /**
         * @generated from field: context_engine.WorkingHoursPerDay working_hours_per_day = 14;
         */
        value: WorkingHoursPerDay;
        case: "workingHoursPerDay";
      }
    | {
        /**
         * @generated from field: context_engine.DocumentInfo document_info = 15;
         */
        value: DocumentInfo;
        case: "documentInfo";
      }
    | {
        /**
         * @generated from field: context_engine.AnswerInfo answer_info = 16;
         */
        value: AnswerInfo;
        case: "answerInfo";
      }
    | {
        /**
         * @generated from field: context_engine.MeetingAttendee meeting_attendee = 17;
         */
        value: MeetingAttendee;
        case: "meetingAttendee";
      }
    | {
        /**
         * @generated from field: context_engine.PageContent page_content = 18;
         */
        value: PageContent;
        case: "pageContent";
      }
    | {
        /**
         * @generated from field: context_engine.PageItem page_item = 19;
         */
        value: PageItem;
        case: "pageItem";
      }
    | {
        /**
         * @generated from field: context_engine.DocumentContent document_content = 20;
         */
        value: DocumentContent;
        case: "documentContent";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ContextEngineModelItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ContextEngineModelItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "int_value",
      kind: "scalar",
      T: 3 /* ScalarType.INT64 */,
      oneof: "data",
    },
    {
      no: 2,
      name: "float_value",
      kind: "scalar",
      T: 2 /* ScalarType.FLOAT */,
      oneof: "data",
    },
    {
      no: 3,
      name: "string_value",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      oneof: "data",
    },
    {
      no: 4,
      name: "bool_value",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
      oneof: "data",
    },
    { no: 5, name: "empty_value", kind: "message", T: Empty, oneof: "data" },
    {
      no: 6,
      name: "datetime_value",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      oneof: "data",
    },
    {
      no: 7,
      name: "authed_user",
      kind: "message",
      T: AuthedUser,
      oneof: "data",
    },
    { no: 8, name: "contact", kind: "message", T: Contact, oneof: "data" },
    { no: 9, name: "time_block", kind: "message", T: TimeBlock, oneof: "data" },
    {
      no: 10,
      name: "working_hours",
      kind: "message",
      T: WorkingHours,
      oneof: "data",
    },
    {
      no: 11,
      name: "meeting_info",
      kind: "message",
      T: MeetingInfo,
      oneof: "data",
    },
    {
      no: 12,
      name: "conflicting_meetings",
      kind: "message",
      T: ConflictingMeetings,
      oneof: "data",
    },
    {
      no: 13,
      name: "context_user_error",
      kind: "message",
      T: ContextUserError,
      oneof: "data",
    },
    {
      no: 14,
      name: "working_hours_per_day",
      kind: "message",
      T: WorkingHoursPerDay,
      oneof: "data",
    },
    {
      no: 15,
      name: "document_info",
      kind: "message",
      T: DocumentInfo,
      oneof: "data",
    },
    {
      no: 16,
      name: "answer_info",
      kind: "message",
      T: AnswerInfo,
      oneof: "data",
    },
    {
      no: 17,
      name: "meeting_attendee",
      kind: "message",
      T: MeetingAttendee,
      oneof: "data",
    },
    {
      no: 18,
      name: "page_content",
      kind: "message",
      T: PageContent,
      oneof: "data",
    },
    { no: 19, name: "page_item", kind: "message", T: PageItem, oneof: "data" },
    {
      no: 20,
      name: "document_content",
      kind: "message",
      T: DocumentContent,
      oneof: "data",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ContextEngineModelItem {
    return new ContextEngineModelItem().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ContextEngineModelItem {
    return new ContextEngineModelItem().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ContextEngineModelItem {
    return new ContextEngineModelItem().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ContextEngineModelItem
      | PlainMessage<ContextEngineModelItem>
      | undefined,
    b:
      | ContextEngineModelItem
      | PlainMessage<ContextEngineModelItem>
      | undefined,
  ): boolean {
    return proto3.util.equals(ContextEngineModelItem, a, b);
  }
}

/**
 * @generated from message context_engine.ContextEngineModel
 */
export class ContextEngineModel extends Message<ContextEngineModel> {
  /**
   * @generated from field: bool is_list = 1;
   */
  isList = false;

  /**
   * @generated from field: repeated context_engine.ContextEngineModelItem items = 2;
   */
  items: ContextEngineModelItem[] = [];

  constructor(data?: PartialMessage<ContextEngineModel>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ContextEngineModel";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_list", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 2,
      name: "items",
      kind: "message",
      T: ContextEngineModelItem,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ContextEngineModel {
    return new ContextEngineModel().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ContextEngineModel {
    return new ContextEngineModel().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ContextEngineModel {
    return new ContextEngineModel().fromJsonString(jsonString, options);
  }

  static equals(
    a: ContextEngineModel | PlainMessage<ContextEngineModel> | undefined,
    b: ContextEngineModel | PlainMessage<ContextEngineModel> | undefined,
  ): boolean {
    return proto3.util.equals(ContextEngineModel, a, b);
  }
}

/**
 * @generated from message context_engine.ContextEngineVars
 */
export class ContextEngineVars extends Message<ContextEngineVars> {
  /**
   * @generated from field: map<string, context_engine.ContextEngineModel> vars = 1;
   */
  vars: { [key: string]: ContextEngineModel } = {};

  constructor(data?: PartialMessage<ContextEngineVars>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ContextEngineVars";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "vars",
      kind: "map",
      K: 9 /* ScalarType.STRING */,
      V: { kind: "message", T: ContextEngineModel },
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ContextEngineVars {
    return new ContextEngineVars().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ContextEngineVars {
    return new ContextEngineVars().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ContextEngineVars {
    return new ContextEngineVars().fromJsonString(jsonString, options);
  }

  static equals(
    a: ContextEngineVars | PlainMessage<ContextEngineVars> | undefined,
    b: ContextEngineVars | PlainMessage<ContextEngineVars> | undefined,
  ): boolean {
    return proto3.util.equals(ContextEngineVars, a, b);
  }
}

/**
 * @generated from message context_engine.UserChoiceRequest
 */
export class UserChoiceRequest extends Message<UserChoiceRequest> {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId = "";

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * @generated from field: string choice_type = 3;
   */
  choiceType = "";

  /**
   * @generated from field: repeated context_engine.ContextEngineModelItem choices = 4;
   */
  choices: ContextEngineModelItem[] = [];

  constructor(data?: PartialMessage<UserChoiceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UserChoiceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "interaction_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 3,
      name: "choice_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 4,
      name: "choices",
      kind: "message",
      T: ContextEngineModelItem,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UserChoiceRequest {
    return new UserChoiceRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UserChoiceRequest {
    return new UserChoiceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UserChoiceRequest {
    return new UserChoiceRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a: UserChoiceRequest | PlainMessage<UserChoiceRequest> | undefined,
    b: UserChoiceRequest | PlainMessage<UserChoiceRequest> | undefined,
  ): boolean {
    return proto3.util.equals(UserChoiceRequest, a, b);
  }
}

/**
 * @generated from message context_engine.UserChoiceResponse
 */
export class UserChoiceResponse extends Message<UserChoiceResponse> {
  /**
   * @generated from field: string interaction_id = 1;
   */
  interactionId = "";

  /**
   * @generated from field: int64 choice_idx = 2;
   */
  choiceIdx = protoInt64.zero;

  constructor(data?: PartialMessage<UserChoiceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UserChoiceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "interaction_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "choice_idx", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UserChoiceResponse {
    return new UserChoiceResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UserChoiceResponse {
    return new UserChoiceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UserChoiceResponse {
    return new UserChoiceResponse().fromJsonString(jsonString, options);
  }

  static equals(
    a: UserChoiceResponse | PlainMessage<UserChoiceResponse> | undefined,
    b: UserChoiceResponse | PlainMessage<UserChoiceResponse> | undefined,
  ): boolean {
    return proto3.util.equals(UserChoiceResponse, a, b);
  }
}

/**
 * @generated from message context_engine.UserInteractionRequest
 */
export class UserInteractionRequest extends Message<UserInteractionRequest> {
  /**
   * @generated from oneof context_engine.UserInteractionRequest.request
   */
  request:
    | {
        /**
         * @generated from field: context_engine.UserChoiceRequest choice = 1;
         */
        value: UserChoiceRequest;
        case: "choice";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UserInteractionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UserInteractionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "choice",
      kind: "message",
      T: UserChoiceRequest,
      oneof: "request",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UserInteractionRequest {
    return new UserInteractionRequest().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UserInteractionRequest {
    return new UserInteractionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UserInteractionRequest {
    return new UserInteractionRequest().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | UserInteractionRequest
      | PlainMessage<UserInteractionRequest>
      | undefined,
    b:
      | UserInteractionRequest
      | PlainMessage<UserInteractionRequest>
      | undefined,
  ): boolean {
    return proto3.util.equals(UserInteractionRequest, a, b);
  }
}

/**
 * @generated from message context_engine.UserInteractionResponse
 */
export class UserInteractionResponse extends Message<UserInteractionResponse> {
  /**
   * @generated from oneof context_engine.UserInteractionResponse.response
   */
  response:
    | {
        /**
         * @generated from field: context_engine.UserChoiceResponse choice = 1;
         */
        value: UserChoiceResponse;
        case: "choice";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UserInteractionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.UserInteractionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "choice",
      kind: "message",
      T: UserChoiceResponse,
      oneof: "response",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): UserInteractionResponse {
    return new UserInteractionResponse().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): UserInteractionResponse {
    return new UserInteractionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): UserInteractionResponse {
    return new UserInteractionResponse().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | UserInteractionResponse
      | PlainMessage<UserInteractionResponse>
      | undefined,
    b:
      | UserInteractionResponse
      | PlainMessage<UserInteractionResponse>
      | undefined,
  ): boolean {
    return proto3.util.equals(UserInteractionResponse, a, b);
  }
}

/**
 * @generated from message context_engine.InterpSerializedContext
 */
export class InterpSerializedContext extends Message<InterpSerializedContext> {
  /**
   * @generated from field: string class_name = 1;
   */
  className = "";

  constructor(data?: PartialMessage<InterpSerializedContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.InterpSerializedContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): InterpSerializedContext {
    return new InterpSerializedContext().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): InterpSerializedContext {
    return new InterpSerializedContext().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): InterpSerializedContext {
    return new InterpSerializedContext().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | InterpSerializedContext
      | PlainMessage<InterpSerializedContext>
      | undefined,
    b:
      | InterpSerializedContext
      | PlainMessage<InterpSerializedContext>
      | undefined,
  ): boolean {
    return proto3.util.equals(InterpSerializedContext, a, b);
  }
}

/**
 * @generated from message context_engine.InterpSerializedData
 */
export class InterpSerializedData extends Message<InterpSerializedData> {
  /**
   * @generated from oneof context_engine.InterpSerializedData.data
   */
  data:
    | {
        /**
         * @generated from field: context_engine.InterpSerializedContext context = 1;
         */
        value: InterpSerializedContext;
        case: "context";
      }
    | {
        /**
         * @generated from field: context_engine.ContextEngineModelItem model = 2;
         */
        value: ContextEngineModelItem;
        case: "model";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<InterpSerializedData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.InterpSerializedData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "context",
      kind: "message",
      T: InterpSerializedContext,
      oneof: "data",
    },
    {
      no: 2,
      name: "model",
      kind: "message",
      T: ContextEngineModelItem,
      oneof: "data",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): InterpSerializedData {
    return new InterpSerializedData().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): InterpSerializedData {
    return new InterpSerializedData().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): InterpSerializedData {
    return new InterpSerializedData().fromJsonString(jsonString, options);
  }

  static equals(
    a: InterpSerializedData | PlainMessage<InterpSerializedData> | undefined,
    b: InterpSerializedData | PlainMessage<InterpSerializedData> | undefined,
  ): boolean {
    return proto3.util.equals(InterpSerializedData, a, b);
  }
}

/**
 * A single content item in a prompt message, either text or image
 *
 * @generated from message context_engine.PromptContentItem
 */
export class PromptContentItem extends Message<PromptContentItem> {
  /**
   * @generated from oneof context_engine.PromptContentItem.content_type
   */
  contentType:
    | {
        /**
         * @generated from field: string text = 1;
         */
        value: string;
        case: "text";
      }
    | {
        /**
         * @generated from field: string image_url = 2;
         */
        value: string;
        case: "imageUrl";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PromptContentItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.PromptContentItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "text",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      oneof: "content_type",
    },
    {
      no: 2,
      name: "image_url",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      oneof: "content_type",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): PromptContentItem {
    return new PromptContentItem().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): PromptContentItem {
    return new PromptContentItem().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): PromptContentItem {
    return new PromptContentItem().fromJsonString(jsonString, options);
  }

  static equals(
    a: PromptContentItem | PlainMessage<PromptContentItem> | undefined,
    b: PromptContentItem | PlainMessage<PromptContentItem> | undefined,
  ): boolean {
    return proto3.util.equals(PromptContentItem, a, b);
  }
}

/**
 * @generated from message context_engine.PromptMessage
 */
export class PromptMessage extends Message<PromptMessage> {
  /**
   * @generated from field: context_engine.PromptMessageRole role = 1;
   */
  role = PromptMessageRole.UNKNOWN;

  /**
   * @generated from oneof context_engine.PromptMessage.content_data
   */
  contentData:
    | {
        /**
         * @generated from field: string content = 2;
         */
        value: string;
        case: "content";
      }
    | {
        /**
         * @generated from field: context_engine.PromptContentItems content_items = 3;
         */
        value: PromptContentItems;
        case: "contentItems";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<PromptMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.PromptMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "role",
      kind: "enum",
      T: proto3.getEnumType(PromptMessageRole),
    },
    {
      no: 2,
      name: "content",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      oneof: "content_data",
    },
    {
      no: 3,
      name: "content_items",
      kind: "message",
      T: PromptContentItems,
      oneof: "content_data",
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): PromptMessage {
    return new PromptMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): PromptMessage {
    return new PromptMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): PromptMessage {
    return new PromptMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a: PromptMessage | PlainMessage<PromptMessage> | undefined,
    b: PromptMessage | PlainMessage<PromptMessage> | undefined,
  ): boolean {
    return proto3.util.equals(PromptMessage, a, b);
  }
}

/**
 * @generated from message context_engine.PromptContentItems
 */
export class PromptContentItems extends Message<PromptContentItems> {
  /**
   * @generated from field: repeated context_engine.PromptContentItem items = 1;
   */
  items: PromptContentItem[] = [];

  constructor(data?: PartialMessage<PromptContentItems>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.PromptContentItems";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "items",
      kind: "message",
      T: PromptContentItem,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): PromptContentItems {
    return new PromptContentItems().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): PromptContentItems {
    return new PromptContentItems().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): PromptContentItems {
    return new PromptContentItems().fromJsonString(jsonString, options);
  }

  static equals(
    a: PromptContentItems | PlainMessage<PromptContentItems> | undefined,
    b: PromptContentItems | PlainMessage<PromptContentItems> | undefined,
  ): boolean {
    return proto3.util.equals(PromptContentItems, a, b);
  }
}

/**
 * Information from user facing clients like web browsers, and mobile/desktop apps.
 *
 * @generated from message context_engine.ClientContext
 */
export class ClientContext extends Message<ClientContext> {
  /**
   * timezone string of the client device, e.g. "America/Los_Angeles"
   *
   * @generated from field: string timezone = 1;
   */
  timezone = "";

  /**
   * Client feature that triggered this request (e.g. stacks, answers, assist, etc)
   *
   * @generated from field: string client_scenario = 2;
   */
  clientScenario = "";

  /**
   * @generated from field: string client_scenario_id = 3;
   */
  clientScenarioId = "";

  constructor(data?: PartialMessage<ClientContext>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ClientContext";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "client_scenario",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 3,
      name: "client_scenario_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ClientContext {
    return new ClientContext().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ClientContext {
    return new ClientContext().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ClientContext {
    return new ClientContext().fromJsonString(jsonString, options);
  }

  static equals(
    a: ClientContext | PlainMessage<ClientContext> | undefined,
    b: ClientContext | PlainMessage<ClientContext> | undefined,
  ): boolean {
    return proto3.util.equals(ClientContext, a, b);
  }
}

/**
 * @generated from message context_engine.QuerySuggestionsGenSettingsProto
 */
export class QuerySuggestionsGenSettingsProto extends Message<QuerySuggestionsGenSettingsProto> {
  /**
   * @generated from field: int32 max_num_docs = 1;
   */
  maxNumDocs = 0;

  /**
   * @generated from field: int32 default_max_query_suggestions_count = 2;
   */
  defaultMaxQuerySuggestionsCount = 0;

  /**
   * @generated from field: int32 max_tokens_per_doc = 3;
   */
  maxTokensPerDoc = 0;

  /**
   * @generated from field: string preferred_query_suggestion_types = 4;
   */
  preferredQuerySuggestionTypes = "";

  /**
   * @generated from field: int32 max_words_per_query_suggestion = 5;
   */
  maxWordsPerQuerySuggestion = 0;

  /**
   * @generated from field: bool same_topic_query_suggestions = 6;
   */
  sameTopicQuerySuggestions = false;

  /**
   * @generated from field: string query_suggestions_gen_llm_system_prompt_template = 7;
   */
  querySuggestionsGenLlmSystemPromptTemplate = "";

  /**
   * @generated from field: string query_suggestions_gen_llm_user_prompt_template = 8;
   */
  querySuggestionsGenLlmUserPromptTemplate = "";

  /**
   * @generated from field: string active_agents = 9;
   */
  activeAgents = "";

  /**
   * @generated from field: bool include_all_docs_in_query_suggestions = 10;
   */
  includeAllDocsInQuerySuggestions = false;

  constructor(data?: PartialMessage<QuerySuggestionsGenSettingsProto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.QuerySuggestionsGenSettingsProto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "max_num_docs",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 2,
      name: "default_max_query_suggestions_count",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 3,
      name: "max_tokens_per_doc",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 4,
      name: "preferred_query_suggestion_types",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 5,
      name: "max_words_per_query_suggestion",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 6,
      name: "same_topic_query_suggestions",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 7,
      name: "query_suggestions_gen_llm_system_prompt_template",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 8,
      name: "query_suggestions_gen_llm_user_prompt_template",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 9,
      name: "active_agents",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 10,
      name: "include_all_docs_in_query_suggestions",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): QuerySuggestionsGenSettingsProto {
    return new QuerySuggestionsGenSettingsProto().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsGenSettingsProto {
    return new QuerySuggestionsGenSettingsProto().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): QuerySuggestionsGenSettingsProto {
    return new QuerySuggestionsGenSettingsProto().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | QuerySuggestionsGenSettingsProto
      | PlainMessage<QuerySuggestionsGenSettingsProto>
      | undefined,
    b:
      | QuerySuggestionsGenSettingsProto
      | PlainMessage<QuerySuggestionsGenSettingsProto>
      | undefined,
  ): boolean {
    return proto3.util.equals(QuerySuggestionsGenSettingsProto, a, b);
  }
}

/**
 * @generated from message context_engine.MultimodalRagConfigsProto
 */
export class MultimodalRagConfigsProto extends Message<MultimodalRagConfigsProto> {
  /**
   * @generated from field: int32 max_concurrency = 1;
   */
  maxConcurrency = 0;

  /**
   * @generated from field: int32 top_k_from_image_chunks_single_doc = 2;
   */
  topKFromImageChunksSingleDoc = 0;

  /**
   * @generated from field: float rag_threshold_for_image_chunks_single_doc = 3;
   */
  ragThresholdForImageChunksSingleDoc = 0;

  /**
   * @generated from field: string rag_model_name_for_image_chunks_single_doc = 4;
   */
  ragModelNameForImageChunksSingleDoc = "";

  constructor(data?: PartialMessage<MultimodalRagConfigsProto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.MultimodalRagConfigsProto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "max_concurrency",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 2,
      name: "top_k_from_image_chunks_single_doc",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 3,
      name: "rag_threshold_for_image_chunks_single_doc",
      kind: "scalar",
      T: 2 /* ScalarType.FLOAT */,
    },
    {
      no: 4,
      name: "rag_model_name_for_image_chunks_single_doc",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): MultimodalRagConfigsProto {
    return new MultimodalRagConfigsProto().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): MultimodalRagConfigsProto {
    return new MultimodalRagConfigsProto().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): MultimodalRagConfigsProto {
    return new MultimodalRagConfigsProto().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | MultimodalRagConfigsProto
      | PlainMessage<MultimodalRagConfigsProto>
      | undefined,
    b:
      | MultimodalRagConfigsProto
      | PlainMessage<MultimodalRagConfigsProto>
      | undefined,
  ): boolean {
    return proto3.util.equals(MultimodalRagConfigsProto, a, b);
  }
}

/**
 * @generated from message context_engine.MapReduceConfigsProto
 */
export class MapReduceConfigsProto extends Message<MapReduceConfigsProto> {
  /**
   * @generated from field: int32 max_concurrency = 1;
   */
  maxConcurrency = 0;

  /**
   * @generated from field: int32 chunk_size_in_tokens = 2;
   */
  chunkSizeInTokens = 0;

  /**
   * @generated from field: int32 chunk_overlap_in_tokens = 3;
   */
  chunkOverlapInTokens = 0;

  /**
   * @generated from field: int32 win_length = 4;
   */
  winLength = 0;

  /**
   * @generated from field: int32 stride = 5;
   */
  stride = 0;

  constructor(data?: PartialMessage<MapReduceConfigsProto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.MapReduceConfigsProto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "max_concurrency",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 2,
      name: "chunk_size_in_tokens",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 3,
      name: "chunk_overlap_in_tokens",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    { no: 4, name: "win_length", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "stride", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): MapReduceConfigsProto {
    return new MapReduceConfigsProto().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): MapReduceConfigsProto {
    return new MapReduceConfigsProto().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): MapReduceConfigsProto {
    return new MapReduceConfigsProto().fromJsonString(jsonString, options);
  }

  static equals(
    a: MapReduceConfigsProto | PlainMessage<MapReduceConfigsProto> | undefined,
    b: MapReduceConfigsProto | PlainMessage<MapReduceConfigsProto> | undefined,
  ): boolean {
    return proto3.util.equals(MapReduceConfigsProto, a, b);
  }
}

/**
 * @generated from message context_engine.DiagnosticsLoggingRateByRetriever
 */
export class DiagnosticsLoggingRateByRetriever extends Message<DiagnosticsLoggingRateByRetriever> {
  /**
   * @generated from field: float fss = 1;
   */
  fss = 0;

  /**
   * @generated from field: float dcs = 2;
   */
  dcs = 0;

  constructor(data?: PartialMessage<DiagnosticsLoggingRateByRetriever>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.DiagnosticsLoggingRateByRetriever";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fss", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "dcs", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): DiagnosticsLoggingRateByRetriever {
    return new DiagnosticsLoggingRateByRetriever().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): DiagnosticsLoggingRateByRetriever {
    return new DiagnosticsLoggingRateByRetriever().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): DiagnosticsLoggingRateByRetriever {
    return new DiagnosticsLoggingRateByRetriever().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | DiagnosticsLoggingRateByRetriever
      | PlainMessage<DiagnosticsLoggingRateByRetriever>
      | undefined,
    b:
      | DiagnosticsLoggingRateByRetriever
      | PlainMessage<DiagnosticsLoggingRateByRetriever>
      | undefined,
  ): boolean {
    return proto3.util.equals(DiagnosticsLoggingRateByRetriever, a, b);
  }
}

/**
 * @generated from message context_engine.HandlerExperimentationConfigProto
 */
export class HandlerExperimentationConfigProto extends Message<HandlerExperimentationConfigProto> {
  /**
   * @generated from field: string llm_system_prompt_template = 1;
   */
  llmSystemPromptTemplate = "";

  /**
   * @generated from field: string llm_user_prompt_template = 2;
   */
  llmUserPromptTemplate = "";

  /**
   * @generated from field: int32 max_num_documents_from_keywords = 3;
   */
  maxNumDocumentsFromKeywords = 0;

  /**
   * @generated from field: bool kw_to_questions_include_recent_doc_titles_in_llm_context = 4;
   */
  kwToQuestionsIncludeRecentDocTitlesInLlmContext = false;

  /**
   * @generated from field: bool include_timezone_in_llm_context = 5;
   */
  includeTimezoneInLlmContext = false;

  /**
   * @generated from field: string kw_to_questions_count_preferred_question_types = 6;
   */
  kwToQuestionsCountPreferredQuestionTypes = "";

  /**
   * @generated from field: int32 kw_to_questions_max_words_per_question = 7;
   */
  kwToQuestionsMaxWordsPerQuestion = 0;

  /**
   * @generated from field: int32 kw_to_questions_max_words_per_answer = 8;
   */
  kwToQuestionsMaxWordsPerAnswer = 0;

  /**
   * @generated from field: int32 max_kw_to_questions_count = 9;
   */
  maxKwToQuestionsCount = 0;

  /**
   * @generated from field: bool llm_markdown_mode = 10;
   */
  llmMarkdownMode = false;

  /**
   * @generated from field: string llm_model = 11;
   */
  llmModel = "";

  /**
   * @generated from field: string llm_model_source = 12;
   */
  llmModelSource = "";

  /**
   * @generated from field: float llm_temperature = 13;
   */
  llmTemperature = 0;

  /**
   * @generated from field: int32 llm_max_output_tokens_per_request = 14;
   */
  llmMaxOutputTokensPerRequest = 0;

  /**
   * @generated from field: bool multi_doc_answering = 15;
   */
  multiDocAnswering = false;

  /**
   * @generated from field: bool combine_documents = 16;
   */
  combineDocuments = false;

  /**
   * @generated from field: bool enable_chunking_v2 = 17;
   */
  enableChunkingV2 = false;

  /**
   * @generated from field: int32 chunk_size = 18;
   */
  chunkSize = 0;

  /**
   * @generated from field: int32 max_context_tokens_per_document = 19;
   */
  maxContextTokensPerDocument = 0;

  /**
   * @generated from field: bool shadow = 20;
   */
  shadow = false;

  /**
   * @generated from field: bool use_context_selection = 21;
   */
  useContextSelection = false;

  /**
   * @generated from field: context_engine.DiagnosticsLoggingRateByRetriever diagnostics_logging_rate_by_retriever = 22;
   */
  diagnosticsLoggingRateByRetriever?: DiagnosticsLoggingRateByRetriever;

  /**
   * @generated from field: int32 surrounding_range_size_for_context = 23;
   */
  surroundingRangeSizeForContext = 0;

  /**
   * @generated from field: int32 top_k_from_semantic_search = 24;
   */
  topKFromSemanticSearch = 0;

  /**
   * @generated from field: float min_semantic_search_similarity = 25;
   */
  minSemanticSearchSimilarity = 0;

  /**
   * @generated from field: int32 top_k_from_tfidf_search = 26;
   */
  topKFromTfidfSearch = 0;

  /**
   * @generated from field: int32 max_semantic_search_corpus_size = 27;
   */
  maxSemanticSearchCorpusSize = 0;

  /**
   * @generated from field: float min_tfidf_search_similarity = 28;
   */
  minTfidfSearchSimilarity = 0;

  /**
   * @generated from field: string kserve_embeddings_gen_model_name = 29;
   */
  kserveEmbeddingsGenModelName = "";

  /**
   * @generated from field: int32 embedding_generation_batch_size = 30;
   */
  embeddingGenerationBatchSize = 0;

  /**
   * @generated from field: bool use_predict_service = 31;
   */
  usePredictService = false;

  /**
   * @generated from field: bool include_title_in_context = 32;
   */
  includeTitleInContext = false;

  /**
   * @generated from field: int32 max_docs_in_context = 33;
   */
  maxDocsInContext = 0;

  /**
   * @generated from field: int32 prior_context_turn_limit = 34;
   */
  priorContextTurnLimit = 0;

  /**
   * @generated from field: int32 prior_context_doc_limit = 35;
   */
  priorContextDocLimit = 0;

  /**
   * @generated from field: int32 num_suggestions = 36;
   */
  numSuggestions = 0;

  /**
   * @generated from field: string references_str = 37;
   */
  referencesStr = "";

  /**
   * @generated from field: context_engine.QuerySuggestionsGenSettingsProto query_suggestions_gen_settings = 38;
   */
  querySuggestionsGenSettings?: QuerySuggestionsGenSettingsProto;

  /**
   * @generated from field: bool enable_v3_bm25_and_semantic_hybrid_retrieval_with_reranking = 39;
   */
  enableV3Bm25AndSemanticHybridRetrievalWithReranking = false;

  /**
   * @generated from field: int32 top_k_from_bm25 = 40;
   */
  topKFromBm25 = 0;

  /**
   * @generated from field: int32 top_k_reranked = 41;
   */
  topKReranked = 0;

  /**
   * @generated from field: string rerank_model_name = 42;
   */
  rerankModelName = "";

  /**
   * @generated from field: bool enable_llm_search_reranker = 43;
   */
  enableLlmSearchReranker = false;

  /**
   * @generated from field: repeated string supported_multimodal_connector_names = 44;
   */
  supportedMultimodalConnectorNames: string[] = [];

  /**
   * @generated from field: repeated string supported_multimodal_file_types = 45;
   */
  supportedMultimodalFileTypes: string[] = [];

  /**
   * @generated from field: repeated string supported_multimodal_file_extensions = 46;
   */
  supportedMultimodalFileExtensions: string[] = [];

  /**
   * @generated from field: repeated string supported_multimodal_image_file_extensions = 47;
   */
  supportedMultimodalImageFileExtensions: string[] = [];

  /**
   * @generated from field: bool include_image_chunks = 48;
   */
  includeImageChunks = false;

  /**
   * @generated from field: bool include_image_chunk_text = 49;
   */
  includeImageChunkText = false;

  /**
   * @generated from field: bool enable_multimodal_riviera_s3_ref = 50;
   */
  enableMultimodalRivieraS3Ref = false;

  /**
   * @generated from field: context_engine.MultimodalRagConfigsProto multimodal_rag_configs = 51;
   */
  multimodalRagConfigs?: MultimodalRagConfigsProto;

  /**
   * @generated from field: string media_type = 52;
   */
  mediaType = "";

  /**
   * @generated from field: bool enable_mapreduce = 53;
   */
  enableMapreduce = false;

  /**
   * @generated from field: int32 use_mapreduce_above_token_limit = 54;
   */
  useMapreduceAboveTokenLimit = 0;

  /**
   * @generated from field: context_engine.MapReduceConfigsProto mapreduce_configs = 55;
   */
  mapreduceConfigs?: MapReduceConfigsProto;

  constructor(data?: PartialMessage<HandlerExperimentationConfigProto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.HandlerExperimentationConfigProto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "llm_system_prompt_template",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 2,
      name: "llm_user_prompt_template",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 3,
      name: "max_num_documents_from_keywords",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 4,
      name: "kw_to_questions_include_recent_doc_titles_in_llm_context",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 5,
      name: "include_timezone_in_llm_context",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 6,
      name: "kw_to_questions_count_preferred_question_types",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 7,
      name: "kw_to_questions_max_words_per_question",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 8,
      name: "kw_to_questions_max_words_per_answer",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 9,
      name: "max_kw_to_questions_count",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 10,
      name: "llm_markdown_mode",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 11, name: "llm_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 12,
      name: "llm_model_source",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 13,
      name: "llm_temperature",
      kind: "scalar",
      T: 2 /* ScalarType.FLOAT */,
    },
    {
      no: 14,
      name: "llm_max_output_tokens_per_request",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 15,
      name: "multi_doc_answering",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 16,
      name: "combine_documents",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 17,
      name: "enable_chunking_v2",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 18, name: "chunk_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    {
      no: 19,
      name: "max_context_tokens_per_document",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    { no: 20, name: "shadow", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 21,
      name: "use_context_selection",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 22,
      name: "diagnostics_logging_rate_by_retriever",
      kind: "message",
      T: DiagnosticsLoggingRateByRetriever,
    },
    {
      no: 23,
      name: "surrounding_range_size_for_context",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 24,
      name: "top_k_from_semantic_search",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 25,
      name: "min_semantic_search_similarity",
      kind: "scalar",
      T: 2 /* ScalarType.FLOAT */,
    },
    {
      no: 26,
      name: "top_k_from_tfidf_search",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 27,
      name: "max_semantic_search_corpus_size",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 28,
      name: "min_tfidf_search_similarity",
      kind: "scalar",
      T: 2 /* ScalarType.FLOAT */,
    },
    {
      no: 29,
      name: "kserve_embeddings_gen_model_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 30,
      name: "embedding_generation_batch_size",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 31,
      name: "use_predict_service",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 32,
      name: "include_title_in_context",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 33,
      name: "max_docs_in_context",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 34,
      name: "prior_context_turn_limit",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 35,
      name: "prior_context_doc_limit",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 36,
      name: "num_suggestions",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 37,
      name: "references_str",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 38,
      name: "query_suggestions_gen_settings",
      kind: "message",
      T: QuerySuggestionsGenSettingsProto,
    },
    {
      no: 39,
      name: "enable_v3_bm25_and_semantic_hybrid_retrieval_with_reranking",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 40,
      name: "top_k_from_bm25",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 41,
      name: "top_k_reranked",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 42,
      name: "rerank_model_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 43,
      name: "enable_llm_search_reranker",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 44,
      name: "supported_multimodal_connector_names",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 45,
      name: "supported_multimodal_file_types",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 46,
      name: "supported_multimodal_file_extensions",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 47,
      name: "supported_multimodal_image_file_extensions",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 48,
      name: "include_image_chunks",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 49,
      name: "include_image_chunk_text",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 50,
      name: "enable_multimodal_riviera_s3_ref",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 51,
      name: "multimodal_rag_configs",
      kind: "message",
      T: MultimodalRagConfigsProto,
    },
    {
      no: 52,
      name: "media_type",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 53,
      name: "enable_mapreduce",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 54,
      name: "use_mapreduce_above_token_limit",
      kind: "scalar",
      T: 5 /* ScalarType.INT32 */,
    },
    {
      no: 55,
      name: "mapreduce_configs",
      kind: "message",
      T: MapReduceConfigsProto,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): HandlerExperimentationConfigProto {
    return new HandlerExperimentationConfigProto().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): HandlerExperimentationConfigProto {
    return new HandlerExperimentationConfigProto().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): HandlerExperimentationConfigProto {
    return new HandlerExperimentationConfigProto().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | HandlerExperimentationConfigProto
      | PlainMessage<HandlerExperimentationConfigProto>
      | undefined,
    b:
      | HandlerExperimentationConfigProto
      | PlainMessage<HandlerExperimentationConfigProto>
      | undefined,
  ): boolean {
    return proto3.util.equals(HandlerExperimentationConfigProto, a, b);
  }
}
